import { useCMSPageField } from '@/cms/fields'
import ReviewsSummary from '@/scopes/products/pages/components/HeroSection/Reviews/ReviewsSummary'
import { useUserReviewsInitialData } from '@/scopes/products/user-reviews/hooks'
import { mqMin, space, tok, tokPx } from '@sunwebgroup/ui-components'
import React from 'react'
import { styled } from 'styled-components'
import { MobileFilters } from '../Filters/MobileFilters'
import { Categories } from './Categories'
import { MostBookedByLabel } from './MostBookedByLabel'
import { ScoreBars } from './ScoreBars'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space('primitives_space_24')};
  padding: ${space('primitives_space_16')};
  width: 100%;
  border-bottom: ${tokPx('semantics_dividers_tickness')} solid ${tok('semantics_boxes_border_color')};
  position: relative;

  &::before {
    content: '';
    width: ${space('primitives_space_16')};
    position: absolute;
    height: 100%;
    background-image: linear-gradient(270deg, hsla(0, 0%, 100%, 0), ${tok('semantics_views_background_color')});
    top: 0;
    left: 0;
    z-index: 1;
  }

  &::after {
    content: '';
    width: ${space('primitives_space_16')};
    position: absolute;
    height: 100%;
    background-image: linear-gradient(90deg, hsla(0, 0%, 100%, 0), ${tok('semantics_views_background_color')});
    top: 0;
    right: 0;
    z-index: 1;
  }

  @media ${mqMin('primitives_breakpoint_m_min')} {
    padding: ${space('primitives_space_24')};
    &::before {
      width: ${space('primitives_space_24')};
    }

    &::after {
      width: ${space('primitives_space_24')};
    }
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    padding: ${space('primitives_space_32')};
    min-width: 350px;
    max-width: 350px;
    border-bottom: unset;
    border-right: ${tokPx('semantics_dividers_tickness')} solid ${tok('semantics_boxes_border_color')};
    overflow-y: auto;
    height: 100%;
}
`

export function Overview() {
  const { reviewsAmount } = useUserReviewsInitialData()
  const ratingsCountDataSource = useCMSPageField('userReviews.ratingsCount')
  const shouldShowSummary = reviewsAmount > 2 && ratingsCountDataSource > 2

  if (!shouldShowSummary)
    return null

  return (
    <>
      <MobileFilters />
      <Wrapper>
        <ReviewsSummary reviewsAmount={reviewsAmount} />
        <ScoreBars />
        <div>
          <MostBookedByLabel />
        </div>
        <Categories />
      </Wrapper>
    </>
  )
}

Overview.Wrapper = Wrapper
